import { useContext } from 'react';
import { useStore } from 'react-redux';

import StarsWidgetContext from '@swf/core/providers/StarsWidgetContext';
import type {
  ExtractDispatchFromModel,
  ExtractSelectFromModel,
  Store,
  WidgetModelConfig
} from '@swf/core/store';

import type { WidgetReference } from '../types/Widget';

/* eslint-disable @typescript-eslint/no-explicit-any */
interface WidgetContext<C extends WidgetReference, M extends WidgetModelConfig<C, any>> {
  widgetConfig: C;
  widgetDispatch: ExtractDispatchFromModel<M>;
  widgetSelect: ExtractSelectFromModel<M>;
  widgetId?: string;
}

export type UseWidget<C extends WidgetReference, M extends WidgetModelConfig<C, any>> = (
  id?: string
) => WidgetContext<C, M>;

export const useWidget = <C extends WidgetReference, M extends WidgetModelConfig<C, any>>(
  id?: string
): WidgetContext<C, M> => {
  const { uid, ...config } = useContext(StarsWidgetContext) || {};
  const store = useStore() as Store;
  const index = (id || uid) as string;
  return {
    widgetConfig: config as C,
    widgetDispatch: store.dispatch[index],
    widgetSelect: store.select[index],
    widgetId: index
  };
};
